import { UserAccount } from '../../../../../../common/client-status/interfaces';

function initialsFrom(firstName: string, lastName: string) {
  const firstInitial = firstName.charAt(0);
  const lastInitial = lastName ? lastName.charAt(0) : '';

  return `${firstInitial}${lastInitial}`.toUpperCase();
}

export const convertUserAccountToInitials = (profile?: UserAccount): string | null => {
  if (!profile) return null;
  if (profile.lastName && profile.firstName) return initialsFrom(profile.firstName, profile.lastName);
  if (profile.firstName) {
    const [firstName, lastName] = profile.firstName.split(' ');
    return initialsFrom(firstName, lastName);
  }
  return initialsFrom(profile.username, '');
};
